module.exports = __webpack_public_path__ + "img/favorite-2.7decca52.svg";